<template>
    <div
        v-if="$router.currentRoute.query.next"
        class="text-center my-4"
    >
        <router-link 
            :to="$router.currentRoute.query.next"
            class="btn btn-outline-primary"
        >
            Next
            <font-awesome-icon
                class="ml-2"
                icon="arrow-right"
            ></font-awesome-icon>
        </router-link>
    </div>
</template>
<script>
export default {
    
}
</script>